import React, { useMemo, useEffect, Fragment } from 'react';
import MaterialReactTable from 'material-react-table';
import { useHistory } from 'react-router-dom';
import Spinner from './Spinner';
import { createCourseFromCourseElement, createCategoriesFromCourseElement,
  findElementinSubElementsByName, uniqueOptions } from '../utils';
const convert = require('xml-js');

const Search = props => {
  const {courses, setCourses, categories, setCategories, isFetching, setIsFetching, tableInstanceRef, columnsToDisplay} = props
  const history = useHistory();
  
  useEffect(() => {
    if (courses === null) {
      const API_URL = "https://cosy.ox.ac.uk/accessplan/services/WebIntegration.asmx/GetCoursesPackageWithCourseDateText";

      let fetchPromises = props.companyIds.map(companyId => {
        return new Promise((resolve, reject) => {
          try {
            let dataAsJson = {};
            fetch(`${API_URL}?companyID=${companyId}&categoryIDs=${props.categoryIds.join('|')}&courseIds=${props.courseIds.join('|')}&venueIds=`)
            .then(response => response.text())
            .then(str => {dataAsJson = JSON.parse(convert.xml2json(str))})
            .then(() => {
              if (
                dataAsJson.elements && dataAsJson.elements.length &&
                dataAsJson.elements[0].elements !== undefined && dataAsJson.elements[0].elements.length &&
                dataAsJson.elements[0].elements[0].elements && dataAsJson.elements[0].elements[0].elements.length
              ) {
                const categoriesTable = createCategoriesFromCourseElement(findElementinSubElementsByName(dataAsJson.elements[0].elements, "Categories"));
  
                let newCourses = [];
                //For each element, create a course result
                dataAsJson.elements[0].elements[0].elements.forEach(courseElement => newCourses.push(createCourseFromCourseElement(courseElement, categoriesTable, companyId)));
                resolve({courses: newCourses, categories: categoriesTable.map(c => c.name)})
              } else {
                resolve({courses: [], categories: []})
              }
            });
          } catch (error) {
            console.log(error);
            resolve({courses: [], categories: []})
          }
        })
      })
      setIsFetching(true)
      Promise.all(fetchPromises)
      .then((promiseResult) => {
        setCourses(promiseResult.map(r => r.courses)
          .flat().sort((a, b) => a.coursename.toLowerCase() < b.coursename.toLowerCase() ? -1 : 1))
        setCategories(promiseResult.map(r => r.categories)
          .flat().sort((a, b) => a.toLowerCase() < b.toLowerCase() ? -1 : 1))
        setIsFetching(false)
      });
    }
  }, [props.companyIds, props.categoryIds, props.courseIds, courses, setCourses, setCategories, setIsFetching])

  const columns = useMemo(
    () => [
      {
        accessorKey: 'coursename',
        header: 'Course title',
        size: 10,
      }, {
        accessorKey: 'coursetype',
        header: 'Delivery',
        size: 10,
        filterVariant: 'multi-select',
        filterSelectOptions: uniqueOptions(courses?.map(course => course.coursetype) || [])
        // if courses === null (not yet fetched) use empty array to initialise filters
      }, {
        accessorKey: 'cost',
        header: 'Cost',
        size: 10,
        filterVariant: 'multi-select',
        filterSelectOptions: uniqueOptions(courses?.map(course => course.cost) || [])
      }, {
        accessorKey: 'categories',
        header: 'Capabilities',
        size: 10,
        filterVariant: 'multi-select',
        filterSelectOptions: uniqueOptions(categories)
      }, {
        accessorKey: 'provider',
        header: 'Provider',
        size: 10,
        filterVariant: 'multi-select',
        filterSelectOptions: uniqueOptions(courses?.map(course => course.provider) || [])
      }, {
        accessorKey: 'duration',
        header: 'Duration',
        size: 10,
      }, {
        accessorKey: 'audience',
        header: 'Audience',
        size: 10,
      }
    ],
    [courses, categories]
  )
  if (isFetching) {
    return <Spinner />
  } else if (courses.length === 0) {
    return <div className="coursedetail col-md-12">No courses available.</div>
  } else {

  const filteredColumns = (columnsToDisplay.length === 0) ?
    columns : columns.filter (column => columnsToDisplay.indexOf(column.header) >= 0);
    
  let orderedColumns = [];
  columnsToDisplay.forEach(col => {
    orderedColumns.push(filteredColumns.filter(obj => { 
      return obj.header === col
    })[0]);
  });

  orderedColumns.forEach(obj => {
    if (obj.header === 'Duration') {
      obj.header = 'Duration (mins)';
    }
  });

  if (orderedColumns.length === 0) orderedColumns = filteredColumns;
  
  return (<Fragment>
      <div className="coursedetail col-md-12">
        <MaterialReactTable
          initialState={tableInstanceRef?.current?.getState()}
          tableInstanceRef={tableInstanceRef}
          columns={orderedColumns}
          data={courses}
          enableRowActions

          enableDensityToggle={false}
          enableColumnFilters={true}
          enableGlobalFilter={true}
          enableHiding={false}
          enableFullScreenToggle={true}
          
          positionActionsColumn="first"
          renderRowActions={({ row }) => (
            <button
              onClick={() => {
                if (props.displayMode === "basic") {
                  window.location = "https://cosy.ox.ac.uk/accessplan/LMSPortal/UI/Page/Courses/book.aspx?courseid=" + row.original.courseid;
                } else {
                  history.push(`/course/${row.original.companyId}/${row.original.courseid}`);
                }
              }}
              color="primary"
              variant="contained"
              style={{ textTransform: 'none', display: 'flex', alignItems: 'center', WebkitAppearance: 'none' }}
              aria-label={"View details for the course "+ row.original.coursename}
              size="small">
                <span className={"material-icons MuiIcon-root"} aria-hidden="true">zoom_in</span><span style={{ 'position': 'relative' }}>View details</span>
            </button>
          )}
          muiTablePaginationProps={{
            rowsPerPageOptions: [10, 20, 50],
          }}
        />
      </div>
    </Fragment>)
  }
}


export default Search
